
// TODO - Type 'any' needs to be fixed.

export const resetMarkAttendanceReducer = (state:any) => {
    state.markAttendance.status = "idle";
    state.markAttendance.errorMessage = "";
}